import { Action } from 'redux'
import { isType } from 'ts-action'
import {
  IAccruedSickHoursReducer,
  IAccruedSickHour,
} from 'models/AccruedSickHour'
import { updateArray, deleteFromArray } from 'helpers/helperFuncs'
import {
  AccruedSickHoursFetching,
  UpdateAccruedSickHour,
  DeleteAccruedSickHour,
} from './actions'

const initialState: IAccruedSickHoursReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const accruedSickHoursReducer = (
  state = initialState,
  action: Action,
): IAccruedSickHoursReducer => {
  if (isType(action, UpdateAccruedSickHour)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IAccruedSickHour>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteAccruedSickHour)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IAccruedSickHour>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, AccruedSickHoursFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
